import type { ReactNode, HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Container({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('mx-auto w-full max-w-[1240px] px-6 md:px-10', className)}
      {...rest}
    >
      {children}
    </div>
  );
}

interface KickerProps {
  index?: string;
  label: string;
  className?: string;
}

export function Kicker({ index, label, className }: KickerProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground',
        className,
      )}
    >
      {index && <span className="text-primary">§ {index}</span>}
      <span className="h-px w-6 bg-border" />
      <span>{label}</span>
    </div>
  );
}

interface DimensionMarkProps {
  value: string;
  className?: string;
}

export function DimensionMark({ value, className }: DimensionMarkProps) {
  return (
    <div
      className={cn(
        'pointer-events-none flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.18em] text-fg-disabled',
        className,
      )}
    >
      <span className="h-px w-3 bg-fg-disabled" />
      <span>{value}</span>
      <span className="h-px w-3 bg-fg-disabled" />
    </div>
  );
}

/* Inline emphasis used inside large Geist headings: keeps the Geist face,
   shifts color to brand orange. We avoid italic-serif drama since the
   design system has no serif — the heading size and the brand color carry
   the emphasis instead. */
export function Mark({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={cn('text-primary', className)}>{children}</span>
  );
}
